module.exports = __webpack_public_path__ + "img/quinton.c62d9e23.svg";